/* Table PARAMETRE - CODE1 - FAMILLE */
const PARAM_FAMILLE_PRODUCTION = "PRODUCTION";
const PARAM_FAMILLE_LAME = "LAME";

/* Table PARAMETRE - CODE2 - SOUSFAMILLE */
const PARAM_CRITERE_CONDITIONNEMENT = "CONDITIONNEMENT";
const PARAM_CRITERE_VOLUME = "VOLUME";
const PARAM_CRITERE_CONCENTRATION_FINALE = "CONCENTRATION_FINALE";

const PARAM_CRITERE_LAME_PROVIDER = "PROVIDER";
const PARAM_CRITERE_LAME_TYPE = "TYPE";

export {
    PARAM_FAMILLE_PRODUCTION,
    PARAM_CRITERE_CONDITIONNEMENT,
    PARAM_CRITERE_VOLUME,
    PARAM_CRITERE_CONCENTRATION_FINALE,

    PARAM_FAMILLE_LAME,
    PARAM_CRITERE_LAME_PROVIDER,
    PARAM_CRITERE_LAME_TYPE
}